import xs from "xstream"
import * as $ from "jquery"

import {nopListener} from "../utils"
import { div } from "@cycle/dom"

const _modalTempl = id => msg => `
<div id="${id}" class="loading">\
	<div class="bkg"></div>\
	<div class="loader"></div>\
</div>
`
export const makeLoadingDriver = (id = "loading") => {
  const loading = div(".loading", [div(".bkg"), div(".loader")])
  const dom$ = xs.create().startWith(null)
	// const modalTempl = _modalTempl(id)
	const showLoading = (doShow) => {
		// if (doShow) {
		// 	if ($(`#${id}`).length === 0) {
		// 		$('#app').append(modalTempl(doShow))
		// 	}
		// } else {
		// 	if ($(`#${id}`).length !== 0) {
		// 		$(`#${id}`).remove()
		// 	}
		// }
    if (doShow) {
      dom$.shamefullySendNext(loading)
    } else {
      dom$.shamefullySendNext(null)
    }
		return doShow
	}
	return sink$ => {
    sink$.map(showLoading).addListener(nopListener("loading"))
    return {
      dom$,
    }
  }
}

